import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { IContentProviderState } from ".";
import { IContentProvider } from "@/models/contentprovider";
import { CProvidersMutationsNames } from "./enums";

export const actions: ActionTree<IContentProviderState, IRootState> = {
    fetchContentProviders({ commit }, uuidSP: string): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "contentproviders"
                ),
                {
                    params: {
                        serviceProviderUuid: uuidSP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    const contentProviderList = response.data.sort(
                        (a: IContentProvider, b: IContentProvider) => {
                            var nameA = a.businessName!.toUpperCase();
                            var nameB = b.businessName!.toUpperCase();
                            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                        }
                    );
                    // mutation to storage sp list
                    commit(
                        CProvidersMutationsNames.SetList,
                        contentProviderList
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(CProvidersMutationsNames.SetError, error);
            });
    },
    setSelectedContentProvider(
        this,
        { commit },
        contentProvider: IContentProvider
    ) {
        commit(CProvidersMutationsNames.SetSelected, contentProvider);
    },
    resetContentProviderState({ commit }): void {
        commit(CProvidersMutationsNames.ResetState);
    },
};
